<template>
  <v-container class="main-container responsive-height">
    <WelcomeSpinner
      :show="showWelcomeSpinner"
      :minSpin="tradableBonusAccountInfo.minSpin"
      :maxSpin="tradableBonusAccountInfo.maxSpin"
      @close="showWelcomeSpinner = false"
      @finished="handleSpinFinished"
    />

    <v-row
      v-if="tradableBonusAccountInfo.TradableBonusCampaignStatus === 1"
      dense
      class="bonus-row"
    >
      <v-col cols="12" md="12">
        <v-sheet
          class="d-flex align-center"
          :color="$vuetify.theme.dark ? '#162334 ' : 'transparent'"
        >
          <div class="content">
            <p>
              To get up to
              <span class="text--green"
                >{{ tradableBonusAccountInfo.maxSpin }}
                {{ tradableBonusAccountInfo.bonusUnit }}</span
              >
              tradable bonus, Create tradable bonus account and deposit
            </p>
            <v-btn
              v-if="tradableBonusAccountInfo.tradableAccountStatus !== 1"
              tile
              elevation="0"
              @click="handleCreateAccount"
            >
              Create Account
            </v-btn>

            <p v-else>
              <span class="text--green">Account Created Successfully</span>
            </p>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row
      v-if="tradableBonusAccountInfo.TradableBonusCampaignStatus === 1"
      dense
      class="bonus-row"
    >
      <v-col cols="12" md="12">
        <v-sheet
          class="d-flex align-center"
          :color="$vuetify.theme.dark ? '#162334 ' : 'transparent'"
        >
          <div
            v-if="tradableBonusAccountInfo.tradableAccountStatus !== 1"
            class="content"
          >
            <p>
              Create your TRADABLE BONUS ACCOUNT using the Spin feature, then
              deposit to earn up to
              <span class="text--green"
                >{{ tradableBonusAccountInfo.maxSpin
                }}{{ tradableBonusAccountInfo.bonusUnit }}</span
              >
              bonus.
            </p>
          </div>
          <div
            v-else-if="tradableBonusAccountInfo.tradableBonusAmount > 0"
            class="content"
          >
            <p>
              You have already received
              <span class="text--green"
                >{{ tradableBonusAccountInfo.tradableBonusAmount }}$ Credit
                IN</span
              >
              as Tradable Bonus in your
              <span class="text--green"
                >{{ tradableBonusAccountInfo.tradablebonusAccount }} ({{
                  tradableBonusAccountInfo.tradableBonusAccountType
                }})</span
              >
              account from your first deposit.
            </p>
            <!-- <v-btn tile elevation="0" to="/deposit"> Get Now </v-btn> -->
          </div>
          <div v-else class="content">
            <p>
              Deposit to your
              <span class="text--green"
                >{{ tradableBonusAccountInfo.tradablebonusAccount }} ({{
                  tradableBonusAccountInfo.tradableBonusAccountType
                }})</span
              >
              ACCOUNT and receive a
              <span class="text--green">{{
                tradableBonusAccountInfo.accountSpinBonus
              }}</span>
              bonus on your first deposit.
            </p>
            <v-btn tile elevation="0" to="/deposit"> Get Now </v-btn>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="7">
        <MyTrading></MyTrading>
      </v-col>
      <v-col cols="12" md="5">
        <MyBalance></MyBalance>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <div class="widgets-card-wrapper">
          <v-card
            v-for="item in forecast"
            :key="item.day"
            outlined
            tile
            :to="item.links"
            :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'"
            class="widgets-card"
          >
            <v-btn
              :ripple="false"
              class="mx-2 mb-3"
              fab
              link
              small
              elevation="0"
              :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F8F6FC'"
            >
              <v-icon color="greenMain">
                {{ item.icon }}
              </v-icon>
            </v-btn>
            <p class="mb-0">{{ item.day }}</p>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" xl="7">
        <MyTradingAccount></MyTradingAccount>
      </v-col>
      <v-col cols="12" xl="5">
        <LineChart></LineChart>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <TransactionsTable></TransactionsTable>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LineChart from "@/components/BarChart/LineChart.vue";
import MyBalance from "@/components/MyBalance/MyBalance.vue";
import MyTrading from "@/components/MyTrading/MyTrading.vue";
import MyTradingAccount from "@/components/MyTrading/MyTradingAccount.vue";
import WelcomeSpinner from "@/components/Spinner/WelcomeSpinner.vue";
import TransactionsTable from "@/components/TransactionsTable/TransactionsTable.vue";
import toast from "@/services/Notification";
import {
  COMPANYINFO__ACTIONS,
  TRADABLEBONUS__ACTIONS,
} from "@/store/action-types";

import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    showWelcomeSpinner: false,
    forecast: [
      // { day: "Web Trader", icon: "mdi-finance", links: "/web-trade" },
      { day: "Deposit", icon: "mdi-tray-arrow-down", links: "/deposit" },
      { day: "Withdraw", icon: "mdi-tray-arrow-up", links: "/withdraw" },
      {
        day: "Internal Transfer",
        icon: "mdi-swap-horizontal",
        links: "/internal-transfer",
      },
      { day: "MT5 Acc.", icon: "mdi-signal", links: "/mt5-accounts" },
      {
        day: "Verification",
        icon: "mdi-account-check-outline",
        links: "/profile-verify",
      },
    ],
  }),
  components: {
    MyTrading,
    MyBalance,
    MyTradingAccount,
    LineChart,
    TransactionsTable,
    WelcomeSpinner,
  },
  computed: {
    ...mapState("company", ["generalInfo"]),
    ...mapState("tradablebonus", ["tradableBonusAccountInfo"]),
  },
  methods: {
    ...mapActions("company", [COMPANYINFO__ACTIONS.COMPANYINFO]),
    ...mapActions("tradablebonus", [
      TRADABLEBONUS__ACTIONS.TRADABLEBONUSACCOUNTINFO,
    ]),
    async handleSpinFinished(spinValue) {
      console.log("Selected Bonus 2:", spinValue);
      try {
        this.showWelcomeSpinner = false;
        const payload = {
          "tradable-spin": spinValue,
        };
        const result = await this.$store.dispatch(
          "tradablebonus/" + TRADABLEBONUS__ACTIONS.CREATETRADABLEBONUSACCOUNT,
          payload
        );
        toast.success(result.message || "Account created successfully!");
      } catch (error) {
        toast.error(error.message || "Failed to create account.");
      }
    },

    handleCreateAccount() {
      // console.log("Account creation logic triggered");
      this.showWelcomeSpinner = true;
    },
  },
  async mounted() {
    await this[COMPANYINFO__ACTIONS.COMPANYINFO]();
    await this[TRADABLEBONUS__ACTIONS.TRADABLEBONUSACCOUNTINFO]();
    document.title = `Dashboard | ${this.generalInfo?.company_name}`;
  },
};
</script>
